module.exports = __webpack_public_path__ + "static/media/tunisia_tell_sahel_1.aad55a9c.jpg";